module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-left-80c4b9fd080f572659e16133ebbdab1c.svg";